import { useState } from 'react';
import styled from 'styled-components';
import Icon from '../Icon';

interface CMTBannerMessageProps {
  type: string;
  message: string;
}

const CMTBannerMessage: React.FC<CMTBannerMessageProps> = ({ type, message }) => {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) {
    return null;
  }
  return (
    <StyledDeviceStatusMessage className={type}>
      {type !== 'alert' && <div className="spacer" />}
      {message}
      {type !== 'alert' && (
        <button className="close-button" onClick={() => setDismissed(true)}>
          <Icon className="close">close</Icon>
        </button>
      )}
    </StyledDeviceStatusMessage>
  );
};

const StyledDeviceStatusMessage = styled.div`
  color: ${(props) => props.theme.colors.secondary};
  font: ${(props) => props.theme.regularBoldFont};
  min-height: 35px;
  text-align: center;
  padding: 5px 0;
  display: flex;
  justify-content: center;
  align-items: center;

  &.info {
    background-color: ${(props) => props.theme.colors.feedback.info};
  }

  &.alert {
    background-color: ${(props) => props.theme.colors.feedback.error};
  }

  & .spacer {
    width: 25px;
    height: 25px;
    margin-right: auto;
  }

  & .close-button {
    display: flex;
    background: none;
    border: none;
    margin-left: auto;
    cursor: pointer;
    align-items: center;

    & .close {
      fill: ${(props) => props.theme.colors.secondary};
      margin: 0;
      height: 25px;
      width: 25px;
    }
  }
`;

export default CMTBannerMessage;
